import { api } from '.'
import {
  AlertSettingsItem,
  AlertTypeEnums,
  ALERT_SETTINGS_GLOBAL_DEVICE_ID,
  ContactTypeEnums,
} from '../common/constants'

const TOTAL_ATTEMPTS = 1
const RETRY_DELAY_IN_MINS = 3

export async function getAlertSettingsFromBackend(deviceId: number, alertType: string) {
  return api.getAlertSettings(deviceId).then((result) => {
    const backendSettings = result.data
      .filter((item: any) => item.deviceId === deviceId)
      .filter((item: any) => item.alertType === alertType)
      .map((item: any) => {
        const { userId, created, updated, ...settings } = item
        return settings
      })

    return BASE_SETTINGS.map((setting: AlertSettingsItem) => {
      const backendSetting = backendSettings.find(
        (item: AlertSettingsItem) => item.contactType === setting.contactType && item.itemOrder === setting.itemOrder
      ) as AlertSettingsItem

      if (backendSetting) return backendSetting
      setting.alertType = alertType as AlertTypeEnums
      return setting
    })
  })
}

export const BASE_SETTINGS = [
  {
    itemOrder: 1,
    enabled: false,
    deviceId: ALERT_SETTINGS_GLOBAL_DEVICE_ID,
    alertType: AlertTypeEnums.SENSOR_ALERTS,
    contactType: ContactTypeEnums.EMAIL,
    contact: '',
    message: '',
    totalAttempts: TOTAL_ATTEMPTS,
    retryDelay: RETRY_DELAY_IN_MINS,
    changed: false,
  },
  {
    itemOrder: 2,
    enabled: false,
    deviceId: ALERT_SETTINGS_GLOBAL_DEVICE_ID,
    alertType: AlertTypeEnums.SENSOR_ALERTS,
    contactType: ContactTypeEnums.EMAIL,
    contact: '',
    message: '',
    totalAttempts: TOTAL_ATTEMPTS,
    retryDelay: RETRY_DELAY_IN_MINS,
    changed: false,
  },
  {
    itemOrder: 3,
    enabled: false,
    deviceId: ALERT_SETTINGS_GLOBAL_DEVICE_ID,
    alertType: AlertTypeEnums.SENSOR_ALERTS,
    contactType: ContactTypeEnums.EMAIL,
    contact: '',
    message: '',
    totalAttempts: TOTAL_ATTEMPTS,
    retryDelay: RETRY_DELAY_IN_MINS,
    changed: false,
  },
  {
    itemOrder: 1,
    enabled: false,
    deviceId: ALERT_SETTINGS_GLOBAL_DEVICE_ID,
    alertType: AlertTypeEnums.SENSOR_ALERTS,
    contactType: ContactTypeEnums.SMS,
    contact: '',
    message: '',
    totalAttempts: TOTAL_ATTEMPTS,
    retryDelay: RETRY_DELAY_IN_MINS,
    changed: false,
  },
  {
    itemOrder: 2,
    enabled: false,
    deviceId: ALERT_SETTINGS_GLOBAL_DEVICE_ID,
    alertType: AlertTypeEnums.SENSOR_ALERTS,
    contactType: ContactTypeEnums.SMS,
    contact: '',
    message: '',
    totalAttempts: TOTAL_ATTEMPTS,
    retryDelay: RETRY_DELAY_IN_MINS,
    changed: false,
  },
  {
    itemOrder: 3,
    enabled: false,
    deviceId: ALERT_SETTINGS_GLOBAL_DEVICE_ID,
    alertType: AlertTypeEnums.SENSOR_ALERTS,
    contactType: ContactTypeEnums.SMS,
    contact: '',
    message: '',
    totalAttempts: TOTAL_ATTEMPTS,
    retryDelay: RETRY_DELAY_IN_MINS,
    changed: false,
  },
]

export const ORDER_ITEMS = [
  {
    itemOrder: 1,
    contactType: ContactTypeEnums.EMAIL,
  },
  {
    itemOrder: 2,
    contactType: ContactTypeEnums.EMAIL,
  },
  {
    itemOrder: 3,
    contactType: ContactTypeEnums.EMAIL,
  },
  {
    itemOrder: 1,
    contactType: ContactTypeEnums.SMS,
  },
  {
    itemOrder: 2,
    contactType: ContactTypeEnums.SMS,
  },
  {
    itemOrder: 3,
    contactType: ContactTypeEnums.SMS,
  },
]
